export const KEY_TOKEN = "access-token";
export const KEY_TOKEN_SDK = "access-token-sdk";
export const KEY_UID = "uid";
export const KEY_NAME = "name";
export const KEY_ROLE = "role";
export const KEY_AVATAR = "avatar";

export const REACT_QUERY = {
  getApplications: "getApplications",
  getDeviceList: "getDeviceList",
  getUserProfile: "getUserProfile",
  getUsers: "getUsers",
  getInternalRequest: "getInternalRequest",
  getExternalRequest: "getExternalRequest",
  getAllApplicationList: "getAllApplicationList",
  getExternalResponse: "getExternalResponse",

  // Person
  getPersonList: "getPersonList",
};
